
import React from 'react';
import './App.css';
import AllRoutes from './routers/Router';

const App: React.FC = () => {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}
export default App;
